import React from 'react'
import {MdLockOutline} from 'react-icons/md'
import { useEffect, useState } from 'react';
import { useNavigate,useLocation, Link } from 'react-router-dom';
import api from '../API/api';
import Loader from '../Modals/Loader';
import { useRef } from 'react';
import Alert from '../Modals/Alert';
import { object, string,number } from 'yup';

export const PasswordReset = () => {
  const [token,setToken] = useState(null);
  const [password,setPassword] = useState(null);
  const [confirmpassword,setconfirmPassword] = useState(null);
  const [code,setCode] = useState(null);

  const loaderRef = useRef()
  const alertRef = useRef()
  const [alertMessage,setAlertMessage] = useState(null)

  const navigate = useNavigate()

  const location = useLocation();
  const state = location.state

  const data = {
    password:password,
    confirm:confirmpassword,
    token:state.token.data,
    code:code
  }

  //check if any of the keys is null
  const dataSchema = object({
    password:string().required('Please Enter password'),
    confirm:string().required('Please Confirm password'),
    token:string().required('Please Confirm password'),
    code:number().required('Code is required')
  })


  const updatePassword = async (e) =>{
    e.preventDefault()
    //fields filling checks
    

    //else send to back-end
    try{
        loaderRef.current.toggleState()
        const finalData = dataSchema.validate(data)
        if(confirmpassword != password){
            setAlertMessage('Passwords do not match')
            alertRef.current.toggleState()
      }
      const response = await api.post(`/users/password`,data);
    
      if(response.request.status === 200){
        navigate(`/login`)
      }

    } catch(err){
        loaderRef.current.toggleState() 
        console.log(err)
        setAlertMessage('Passwords Reset Failed')
        alertRef.current.toggleState()
        return
    }
    
  }

  useEffect(()=>{
    setToken('mckewmlkmdlqwmdqmdkwqdrfw')
  },[])

  return (
    <>
      <div className="flex flex-col w-full items-center justify-center text-center min-h-screen bg-gray-100 py-2 px-20">
      <div className="bg-white rounded-2xl shadow-2xl flex w-2/3 max-w-4xl">
        <div className="w-3/5 p-5">
          <div className="text-left font-bold">
          Propel Health
          </div>
          <div className="py-10">
            <h2 className="font-bold text-3xl mb-6">Reset Account Password</h2>
            {/*Social media login section*/}
            <p className="text-gray-400 font-semibold my-3">or use your email</p>
            <div className="flex flex-col items-center">
              <div className="bg-gray-100 w-64 flex items-center mb-3">
                <input onChange={(e)=>setPassword(e.target.value)} type="password" name="Password" placeholder="Enter New Password" 
                className="bg-gray-100 border py-2.5 px-3 border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" ></input>
              </div>
              <div className="bg-gray-100 w-64  flex items-center mb-3">
                <input onChange={(e)=>setconfirmPassword(e.target.value)} type="password" name="confirm Password" placeholder="Confirm Password" 
                className="bg-gray-100 border py-2.5 px-3 border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" ></input>
              </div>
              <div className="bg-gray-100 w-64 flex items-center mb-3">
                <input onChange={(e)=>setCode(e.target.value)} type="text" name="confirm Password" placeholder="Enter Reset Code" 
                className="bg-gray-100 border py-2.5 px-3 border-gray-300 outline-none flex-1 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black" ></input>
              </div>
              <a onClick={(e)=>updatePassword(e)} href="#" className="border-2 border-precision rounded-full px-12 py-2 inline-block font-semibold hover:bg-precision hover:text-white disabled:cursor-not-allowed" >Reset Password</a>
            </div>
          </div>
        </div>
        <div className="w-2/5 bg-[#1C1C1C] text-white rounded-tr-2xl rounded-br-2xl py-36 px-12">
          <h3 className="text-3xl font-bold mb-2">Propel Health</h3>
          <div className="border-2 w-40 border-white inline-block"></div>
        </div>
      </div>
    </div>
    <Loader ref={loaderRef}/>
    <Alert ref={alertRef} message={alertMessage}/>
    </>
    
  )
}
